import React from 'react'

const ChartSection = () => {
  return (
    <div className="chart-section bg flex center column" id='chart'>
      <h1>Chart Section</h1>
      <h4>
        Working on it
      </h4>
    </div>
  )
}

export default ChartSection